export const signUpText = 'Sign Up';
export const loginText = 'Login';
export const homeLink = 'https://musiversal.com';
